import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transform: translateX(14px);

  ${props => props.$small && css`
    transform: translate(-5px, 4px);
  `}
`;
